module.exports = __webpack_public_path__ + "media/packs/images/flags/SI-c160fdff99a31cfc5952aaf253078ad6.png";